export interface FtaResult {
    annualIncomeAmount: any;
    finalPaymentMethod: any;
}

export interface FtaInputs {
    investmentAmount: any;
    investmentTerm: any;
    product: string;
}

export const FTAResultsData = {
  investmentAmount: 'Investment amount',
  investmentTerm: 'Investment term',
  annualIncomeAmount: 'Annual income amount',
  finalPaymentMethod: 'Final payment method',
} as any;

export const ProductNames = {
  'Max Income': 'Maximum Income Option',
  'Max Lump Sum': 'Maximum Lump Sum Option',
  Combo: 'Combination Option',
} as any;
